
const digest = 'f062f8dfdbd54dfca4f99b004dfa2e637dd4cb94549f65d330f45836dd0b39d3';
const classes = {"wrapper":"_wrapper_r1atw_1","controls":"_controls_r1atw_7","text":"_text_r1atw_13","content":"_content_r1atw_20"};
const css = `._wrapper_r1atw_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_r1atw_1 ._controls_r1atw_7 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
._wrapper_r1atw_1 ._controls_r1atw_7 ._text_r1atw_13 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  font-size: 14px;
}
._wrapper_r1atw_1 ._content_r1atw_20 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  